module.exports = __webpack_public_path__ + "static/media/480.8c067534.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-tree-planting/dark/480.png
// module id = 2510
// module chunks = 2